import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  loader = new Subject<boolean>();
  loadingBypass: string[] = [];

  constructor() { }

  getLoaderStatus(): Observable<any> {
    return this.loader.asObservable();
  }

  start() {
    this.loader.next(true);
  }

  stop() {
    this.loader.next(false);
  }

  addLoadingBypass(url: string) {
    this.loadingBypass.push(url);
  }

  removeLoadingBypass(url: string) {
    this.loadingBypass.splice(this.loadingBypass.indexOf(url))
  }
}
